import { render, staticRenderFns } from "./navColorSet.vue?vue&type=template&id=51780b1e&scoped=true&"
import script from "./navColorSet.vue?vue&type=script&lang=ts&"
export * from "./navColorSet.vue?vue&type=script&lang=ts&"
import style0 from "./navColorSet.vue?vue&type=style&index=0&id=51780b1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51780b1e",
  null
  
)

export default component.exports